module.exports = __webpack_public_path__ + "img/PVC-02.8645c121.png";